/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as AuthenticatedRouteImport } from "./routes/_authenticated"
import { Route as LoginRouteImport } from "./routes/login"
import { Route as AuthenticatedIndexRouteImport } from "./routes/_authenticated/index"
import { Route as AuthenticatedChangePasswordRouteImport } from "./routes/_authenticated/change-password"
import { Route as AuthenticatedScrapesRouteImport } from "./routes/_authenticated/scrapes"
import { Route as AuthenticatedSettingsRouteImport } from "./routes/_authenticated/settings"
import { Route as AuthenticatedAdminNotificationsRouteImport } from "./routes/_authenticated/admin/notifications"
import { Route as AuthenticatedAdminRejectionsRouteImport } from "./routes/_authenticated/admin/rejections"
import { Route as AuthenticatedApartmentsIndexRouteImport } from "./routes/_authenticated/apartments/index"
import { Route as AuthenticatedApartmentsIdRouteImport } from "./routes/_authenticated/apartments/$id"
import { Route as AuthenticatedFiltersIndexRouteImport } from "./routes/_authenticated/filters/index"
import { Route as AuthenticatedFiltersNewRouteImport } from "./routes/_authenticated/filters/new"
import { Route as AuthenticatedFiltersIdEditRouteImport } from "./routes/_authenticated/filters/$id.edit"
import { Route as AuthenticatedMessagesComposeIdRouteImport } from "./routes/_authenticated/messages/compose.$id"

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: "/_authenticated",
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedChangePasswordRoute =
  AuthenticatedChangePasswordRouteImport.update({
    id: "/change-password",
    path: "/change-password",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedScrapesRoute = AuthenticatedScrapesRouteImport.update({
  id: "/scrapes",
  path: "/scrapes",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: "/settings",
  path: "/settings",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAdminNotificationsRoute =
  AuthenticatedAdminNotificationsRouteImport.update({
    id: "/admin/notifications",
    path: "/admin/notifications",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminRejectionsRoute =
  AuthenticatedAdminRejectionsRouteImport.update({
    id: "/admin/rejections",
    path: "/admin/rejections",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedApartmentsIndexRoute =
  AuthenticatedApartmentsIndexRouteImport.update({
    id: "/apartments/",
    path: "/apartments/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedApartmentsIdRoute =
  AuthenticatedApartmentsIdRouteImport.update({
    id: "/apartments/$id",
    path: "/apartments/$id",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFiltersIndexRoute =
  AuthenticatedFiltersIndexRouteImport.update({
    id: "/filters/",
    path: "/filters/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFiltersNewRoute = AuthenticatedFiltersNewRouteImport.update({
  id: "/filters/new",
  path: "/filters/new",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedFiltersIdEditRoute =
  AuthenticatedFiltersIdEditRouteImport.update({
    id: "/filters/$id/edit",
    path: "/filters/$id/edit",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMessagesComposeIdRoute =
  AuthenticatedMessagesComposeIdRouteImport.update({
    id: "/messages/compose/$id",
    path: "/messages/compose/$id",
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  "/": typeof AuthenticatedIndexRoute
  "/login": typeof LoginRoute
  "/change-password": typeof AuthenticatedChangePasswordRoute
  "/scrapes": typeof AuthenticatedScrapesRoute
  "/settings": typeof AuthenticatedSettingsRoute
  "/admin/notifications": typeof AuthenticatedAdminNotificationsRoute
  "/admin/rejections": typeof AuthenticatedAdminRejectionsRoute
  "/apartments/$id": typeof AuthenticatedApartmentsIdRoute
  "/filters/new": typeof AuthenticatedFiltersNewRoute
  "/apartments/": typeof AuthenticatedApartmentsIndexRoute
  "/filters/": typeof AuthenticatedFiltersIndexRoute
  "/filters/$id/edit": typeof AuthenticatedFiltersIdEditRoute
  "/messages/compose/$id": typeof AuthenticatedMessagesComposeIdRoute
}
export interface FileRoutesByTo {
  "/login": typeof LoginRoute
  "/change-password": typeof AuthenticatedChangePasswordRoute
  "/scrapes": typeof AuthenticatedScrapesRoute
  "/settings": typeof AuthenticatedSettingsRoute
  "/": typeof AuthenticatedIndexRoute
  "/admin/notifications": typeof AuthenticatedAdminNotificationsRoute
  "/admin/rejections": typeof AuthenticatedAdminRejectionsRoute
  "/apartments/$id": typeof AuthenticatedApartmentsIdRoute
  "/filters/new": typeof AuthenticatedFiltersNewRoute
  "/apartments": typeof AuthenticatedApartmentsIndexRoute
  "/filters": typeof AuthenticatedFiltersIndexRoute
  "/filters/$id/edit": typeof AuthenticatedFiltersIdEditRoute
  "/messages/compose/$id": typeof AuthenticatedMessagesComposeIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/_authenticated": typeof AuthenticatedRouteWithChildren
  "/login": typeof LoginRoute
  "/_authenticated/change-password": typeof AuthenticatedChangePasswordRoute
  "/_authenticated/scrapes": typeof AuthenticatedScrapesRoute
  "/_authenticated/settings": typeof AuthenticatedSettingsRoute
  "/_authenticated/": typeof AuthenticatedIndexRoute
  "/_authenticated/admin/notifications": typeof AuthenticatedAdminNotificationsRoute
  "/_authenticated/admin/rejections": typeof AuthenticatedAdminRejectionsRoute
  "/_authenticated/apartments/$id": typeof AuthenticatedApartmentsIdRoute
  "/_authenticated/filters/new": typeof AuthenticatedFiltersNewRoute
  "/_authenticated/apartments/": typeof AuthenticatedApartmentsIndexRoute
  "/_authenticated/filters/": typeof AuthenticatedFiltersIndexRoute
  "/_authenticated/filters/$id/edit": typeof AuthenticatedFiltersIdEditRoute
  "/_authenticated/messages/compose/$id": typeof AuthenticatedMessagesComposeIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/login"
    | "/change-password"
    | "/scrapes"
    | "/settings"
    | "/admin/notifications"
    | "/admin/rejections"
    | "/apartments/$id"
    | "/filters/new"
    | "/apartments/"
    | "/filters/"
    | "/filters/$id/edit"
    | "/messages/compose/$id"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/login"
    | "/change-password"
    | "/scrapes"
    | "/settings"
    | "/"
    | "/admin/notifications"
    | "/admin/rejections"
    | "/apartments/$id"
    | "/filters/new"
    | "/apartments"
    | "/filters"
    | "/filters/$id/edit"
    | "/messages/compose/$id"
  id:
    | "__root__"
    | "/_authenticated"
    | "/login"
    | "/_authenticated/change-password"
    | "/_authenticated/scrapes"
    | "/_authenticated/settings"
    | "/_authenticated/"
    | "/_authenticated/admin/notifications"
    | "/_authenticated/admin/rejections"
    | "/_authenticated/apartments/$id"
    | "/_authenticated/filters/new"
    | "/_authenticated/apartments/"
    | "/_authenticated/filters/"
    | "/_authenticated/filters/$id/edit"
    | "/_authenticated/messages/compose/$id"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/_authenticated": {
      id: "/_authenticated"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/login": {
      id: "/login"
      path: "/login"
      fullPath: "/login"
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authenticated/": {
      id: "/_authenticated/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/change-password": {
      id: "/_authenticated/change-password"
      path: "/change-password"
      fullPath: "/change-password"
      preLoaderRoute: typeof AuthenticatedChangePasswordRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/scrapes": {
      id: "/_authenticated/scrapes"
      path: "/scrapes"
      fullPath: "/scrapes"
      preLoaderRoute: typeof AuthenticatedScrapesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/settings": {
      id: "/_authenticated/settings"
      path: "/settings"
      fullPath: "/settings"
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/admin/notifications": {
      id: "/_authenticated/admin/notifications"
      path: "/admin/notifications"
      fullPath: "/admin/notifications"
      preLoaderRoute: typeof AuthenticatedAdminNotificationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/admin/rejections": {
      id: "/_authenticated/admin/rejections"
      path: "/admin/rejections"
      fullPath: "/admin/rejections"
      preLoaderRoute: typeof AuthenticatedAdminRejectionsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/apartments/": {
      id: "/_authenticated/apartments/"
      path: "/apartments"
      fullPath: "/apartments/"
      preLoaderRoute: typeof AuthenticatedApartmentsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/apartments/$id": {
      id: "/_authenticated/apartments/$id"
      path: "/apartments/$id"
      fullPath: "/apartments/$id"
      preLoaderRoute: typeof AuthenticatedApartmentsIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/filters/": {
      id: "/_authenticated/filters/"
      path: "/filters"
      fullPath: "/filters/"
      preLoaderRoute: typeof AuthenticatedFiltersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/filters/new": {
      id: "/_authenticated/filters/new"
      path: "/filters/new"
      fullPath: "/filters/new"
      preLoaderRoute: typeof AuthenticatedFiltersNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/filters/$id/edit": {
      id: "/_authenticated/filters/$id/edit"
      path: "/filters/$id/edit"
      fullPath: "/filters/$id/edit"
      preLoaderRoute: typeof AuthenticatedFiltersIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/messages/compose/$id": {
      id: "/_authenticated/messages/compose/$id"
      path: "/messages/compose/$id"
      fullPath: "/messages/compose/$id"
      preLoaderRoute: typeof AuthenticatedMessagesComposeIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedChangePasswordRoute: typeof AuthenticatedChangePasswordRoute
  AuthenticatedScrapesRoute: typeof AuthenticatedScrapesRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedAdminNotificationsRoute: typeof AuthenticatedAdminNotificationsRoute
  AuthenticatedAdminRejectionsRoute: typeof AuthenticatedAdminRejectionsRoute
  AuthenticatedApartmentsIdRoute: typeof AuthenticatedApartmentsIdRoute
  AuthenticatedFiltersNewRoute: typeof AuthenticatedFiltersNewRoute
  AuthenticatedApartmentsIndexRoute: typeof AuthenticatedApartmentsIndexRoute
  AuthenticatedFiltersIndexRoute: typeof AuthenticatedFiltersIndexRoute
  AuthenticatedFiltersIdEditRoute: typeof AuthenticatedFiltersIdEditRoute
  AuthenticatedMessagesComposeIdRoute: typeof AuthenticatedMessagesComposeIdRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedChangePasswordRoute: AuthenticatedChangePasswordRoute,
  AuthenticatedScrapesRoute: AuthenticatedScrapesRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedAdminNotificationsRoute: AuthenticatedAdminNotificationsRoute,
  AuthenticatedAdminRejectionsRoute: AuthenticatedAdminRejectionsRoute,
  AuthenticatedApartmentsIdRoute: AuthenticatedApartmentsIdRoute,
  AuthenticatedFiltersNewRoute: AuthenticatedFiltersNewRoute,
  AuthenticatedApartmentsIndexRoute: AuthenticatedApartmentsIndexRoute,
  AuthenticatedFiltersIndexRoute: AuthenticatedFiltersIndexRoute,
  AuthenticatedFiltersIdEditRoute: AuthenticatedFiltersIdEditRoute,
  AuthenticatedMessagesComposeIdRoute: AuthenticatedMessagesComposeIdRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
